export const inputFieldLabels = {
  firstName: "First Name",
  lastName: "Last Name",
  originCountry: "Origin Country",
  projectCode: "Project Code",
  description: "Description",
  paymentAmount: "Payment Amount",
  paymentCurrency: "Payment Currency",
  validityStartDate: "Validity Start Date",
  validityEndDate: "Validity End Date",
};

export const allCountries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Angola",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "CEMAC",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "European Union",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Organisation of Eastern Caribbean States",
  "Pakistan",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "São Tomé and Príncipe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const opecCountries = [
  "Algeria",
  "Congo",
  "Equatorial Guinea",
  "Gabon",
  "Iran",
  "Iraq",
  "Kuwait",
  "Libya",
  "Nigeria",
  "Saudi Arabia",
  "United Arab Emirates",
  "Venezuela",
];

export const currencies = [
  {
    "currencyCode": "AFN",
    "currencyName": "Afghan Afghani",
  },
  {
    "currencyCode": "ALL",
    "currencyName": "Albanian Lek",
  },
  {
    "currencyCode": "DZD",
    "currencyName": "Algerian Dinar",
  },
  {
    "currencyCode": "AOA",
    "currencyName": "Angolan Kwanza",
  },
  {
    "currencyCode": "ARS",
    "currencyName": "Argentine Peso",
  },
  {
    "currencyCode": "AMD",
    "currencyName": "Armenian Dram",
  },
  {
    "currencyCode": "AWG",
    "currencyName": "Aruban Florin",
  },
  {
    "currencyCode": "AUD",
    "currencyName": "Australian Dollar",
  },
  {
    "currencyCode": "AZN",
    "currencyName": "Azerbaijani Manat",
  },
  {
    "currencyCode": "BSD",
    "currencyName": "Bahamian Dollar",
  },
  {
    "currencyCode": "BHD",
    "currencyName": "Bahraini Dinar",
  },
  {
    "currencyCode": "BDT",
    "currencyName": "Bangladeshi Taka",
  },
  {
    "currencyCode": "BBD",
    "currencyName": "Barbados Dollar",
  },
  {
    "currencyCode": "BYN",
    "currencyName": "Belarusian Ruble",
  },
  {
    "currencyCode": "BZD",
    "currencyName": "Belize Dollar",
  },
  {
    "currencyCode": "BMD",
    "currencyName": "Bermudian Dollar",
  },
  {
    "currencyCode": "BTN",
    "currencyName": "Bhutanese Ngultrum",
  },
  {
    "currencyCode": "BOB",
    "currencyName": "Bolivian Boliviano",
  },
  {
    "currencyCode": "BAM",
    "currencyName": "Bosnia and Herzegovina Mark",
  },
  {
    "currencyCode": "BWP",
    "currencyName": "Botswana Pula",
  },
  {
    "currencyCode": "BRL",
    "currencyName": "Brazilian Real",
  },
  {
    "currencyCode": "BND",
    "currencyName": "Brunei Dollar",
  },
  {
    "currencyCode": "BGN",
    "currencyName": "Bulgarian Lev",
  },
  {
    "currencyCode": "BIF",
    "currencyName": "Burundian Franc",
  },
  {
    "currencyCode": "XAF",
    "currencyName": "Central African CFA Franc",
  },
  {
    "currencyCode": "XOF",
    "currencyName": "West African CFA franc",
  },
  {
    "currencyCode": "KHR",
    "currencyName": "Cambodian Riel",
  },
  {
    "currencyCode": "CAD",
    "currencyName": "Canadian Dollar",
  },
  {
    "currencyCode": "CVE",
    "currencyName": "Cape Verdean Escudo",
  },
  {
    "currencyCode": "KYD",
    "currencyName": "Cayman Islands Dollar",
  },
  {
    "currencyCode": "CLP",
    "currencyName": "Chilean Peso",
  },
  {
    "currencyCode": "CNY",
    "currencyName": "Chinese Renminbi",
  },
  {
    "currencyCode": "XPF",
    "currencyName": "CFP Franc",
  },
  {
    "currencyCode": "COP",
    "currencyName": "Colombian Peso",
  },
  {
    "currencyCode": "KMF",
    "currencyName": "Comorian Franc",
  },
  {
    "currencyCode": "CRC",
    "currencyName": "Costa Rican Colon",
  },
  {
    "currencyCode": "HRK",
    "currencyName": "Croatian Kuna",
  },
  {
    "currencyCode": "CUP",
    "currencyName": "Cuban Peso",
  },
  {
    "currencyCode": "CZK",
    "currencyName": "Czech Koruna",
  },
  {
    "currencyCode": "CDF",
    "currencyName": "Congolese Franc",
  },
  {
    "currencyCode": "DKK",
    "currencyName": "Danish Krone",
  },
  {
    "currencyCode": "DJF",
    "currencyName": "Djiboutian Franc",
  },
  {
    "currencyCode": "EGP",
    "currencyName": "Egyptian Pound",
  },
  {
    "currencyCode": "ERN",
    "currencyName": "Eritrean Nakfa",
  },
  {
    "currencyCode": "SZL",
    "currencyName": "Eswatini Lilangeni",
  },
  {
    "currencyCode": "ETB",
    "currencyName": "Ethiopian Birr",
  },
  {
    "currencyCode": "EUR",
    "currencyName": "Euro",
  },
  {
    "currencyCode": "FKP",
    "currencyName": "Falkland Islands Pound",
  },
  {
    "currencyCode": "FOK",
    "currencyName": "Faroese Króna",
  },
  {
    "currencyCode": "FJD",
    "currencyName": "Fiji Dollar",
  },
  {
    "currencyCode": "GEL",
    "currencyName": "Georgian Lari",
  },
  {
    "currencyCode": "GHS",
    "currencyName": "Ghanaian Cedi",
  },
  {
    "currencyCode": "GIP",
    "currencyName": "Gibraltar Pound",
  },
  {
    "currencyCode": "GTQ",
    "currencyName": "Guatemalan Quetzal",
  },
  {
    "currencyCode": "GGP",
    "currencyName": "Guernsey Pound",
  },
  {
    "currencyCode": "GNF",
    "currencyName": "Guinean Franc",
  },
  {
    "currencyCode": "GYD",
    "currencyName": "Guyanese Dollar",
  },
  {
    "currencyCode": "HTG",
    "currencyName": "Haitian Gourde",
  },
  {
    "currencyCode": "HNL",
    "currencyName": "Honduran Lempira",
  },
  {
    "currencyCode": "HKD",
    "currencyName": "Hong Kong Dollar",
  },
  {
    "currencyCode": "HUF",
    "currencyName": "Hungarian Forint",
  },
  {
    "currencyCode": "ISK",
    "currencyName": "Icelandic Króna",
  },
  {
    "currencyCode": "INR",
    "currencyName": "Indian Rupee",
  },
  {
    "currencyCode": "IDR",
    "currencyName": "Indonesian Rupiah",
  },
  {
    "currencyCode": "XDR",
    "currencyName": "Special Drawing Rights",
  },
  {
    "currencyCode": "IRR",
    "currencyName": "Iranian Rial",
  },
  {
    "currencyCode": "IQD",
    "currencyName": "Iraqi Dinar",
  },
  {
    "currencyCode": "IMP",
    "currencyName": "Manx Pound",
  },
  {
    "currencyCode": "ILS",
    "currencyName": "Israeli New Shekel",
  },
  {
    "currencyCode": "JMD",
    "currencyName": "Jamaican Dollar",
  },
  {
    "currencyCode": "JPY",
    "currencyName": "Japanese Yen",
  },
  {
    "currencyCode": "JEP",
    "currencyName": "Jersey Pound",
  },
  {
    "currencyCode": "JOD",
    "currencyName": "Jordanian Dinar",
  },
  {
    "currencyCode": "KZT",
    "currencyName": "Kazakhstani Tenge",
  },
  {
    "currencyCode": "KES",
    "currencyName": "Kenyan Shilling",
  },
  {
    "currencyCode": "KID",
    "currencyName": "Kiribati Dollar",
  },
  {
    "currencyCode": "KWD",
    "currencyName": "Kuwaiti Dinar",
  },
  {
    "currencyCode": "KGS",
    "currencyName": "Kyrgyzstani Som",
  },
  {
    "currencyCode": "LAK",
    "currencyName": "Lao Kip",
  },
  {
    "currencyCode": "LBP",
    "currencyName": "Lebanese Pound",
  },
  {
    "currencyCode": "LSL",
    "currencyName": "Lesotho Loti",
  },
  {
    "currencyCode": "LRD",
    "currencyName": "Liberian Dollar",
  },
  {
    "currencyCode": "LYD",
    "currencyName": "Libyan Dinar",
  },
  {
    "currencyCode": "MOP",
    "currencyName": "Macanese Pataca",
  },
  {
    "currencyCode": "MGA",
    "currencyName": "Malagasy Ariary",
  },
  {
    "currencyCode": "MWK",
    "currencyName": "Malawian Kwacha",
  },
  {
    "currencyCode": "MYR",
    "currencyName": "Malaysian Ringgit",
  },
  {
    "currencyCode": "MVR",
    "currencyName": "Maldivian Rufiyaa",
  },
  {
    "currencyCode": "MRU",
    "currencyName": "Mauritanian Ouguiya",
  },
  {
    "currencyCode": "MUR",
    "currencyName": "Mauritian Rupee",
  },
  {
    "currencyCode": "MXN",
    "currencyName": "Mexican Peso",
  },
  {
    "currencyCode": "MDL",
    "currencyName": "Moldovan Leu",
  },
  {
    "currencyCode": "MNT",
    "currencyName": "Mongolian Tögrög",
  },
  {
    "currencyCode": "MAD",
    "currencyName": "Moroccan Dirham",
  },
  {
    "currencyCode": "MZN",
    "currencyName": "Mozambican Metical",
  },
  {
    "currencyCode": "MMK",
    "currencyName": "Burmese Kyat",
  },
  {
    "currencyCode": "NAD",
    "currencyName": "Namibian Dollar",
  },
  {
    "currencyCode": "NPR",
    "currencyName": "Nepalese Rupee",
  },
  {
    "currencyCode": "ANG",
    "currencyName": "Netherlands Antillian Guilder",
  },
  {
    "currencyCode": "NZD",
    "currencyName": "New Zealand Dollar",
  },
  {
    "currencyCode": "NIO",
    "currencyName": "Nicaraguan Córdoba",
  },
  {
    "currencyCode": "NGN",
    "currencyName": "Nigerian Naira",
  },
  {
    "currencyCode": "MKD",
    "currencyName": "Macedonian Denar",
  },
  {
    "currencyCode": "NOK",
    "currencyName": "Norwegian Krone",
  },
  {
    "currencyCode": "OMR",
    "currencyName": "Omani Rial",
  },
  {
    "currencyCode": "XCD",
    "currencyName": "East Caribbean Dollar",
  },
  {
    "currencyCode": "PKR",
    "currencyName": "Pakistani Rupee",
  },
  {
    "currencyCode": "PAB",
    "currencyName": "Panamanian Balboa",
  },
  {
    "currencyCode": "PGK",
    "currencyName": "Papua New Guinean Kina",
  },
  {
    "currencyCode": "PYG",
    "currencyName": "Paraguayan Guaraní",
  },
  {
    "currencyCode": "PEN",
    "currencyName": "Peruvian Sol",
  },
  {
    "currencyCode": "PHP",
    "currencyName": "Philippine Peso",
  },
  {
    "currencyCode": "PLN",
    "currencyName": "Polish Złoty",
  },
  {
    "currencyCode": "QAR",
    "currencyName": "Qatari Riyal",
  },
  {
    "currencyCode": "RON",
    "currencyName": "Romanian Leu",
  },
  {
    "currencyCode": "RUB",
    "currencyName": "Russian Ruble",
  },
  {
    "currencyCode": "RWF",
    "currencyName": "Rwandan Franc",
  },
  {
    "currencyCode": "SHP",
    "currencyName": "Saint Helena Pound",
  },
  {
    "currencyCode": "WST",
    "currencyName": "Samoan Tālā",
  },
  {
    "currencyCode": "SAR",
    "currencyName": "Saudi Riyal",
  },
  {
    "currencyCode": "RSD",
    "currencyName": "Serbian Dinar",
  },
  {
    "currencyCode": "SCR",
    "currencyName": "Seychellois Rupee",
  },
  {
    "currencyCode": "SLE",
    "currencyName": "Sierra Leonean Leone",
  },
  {
    "currencyCode": "SGD",
    "currencyName": "Singapore Dollar",
  },
  {
    "currencyCode": "SBD",
    "currencyName": "Solomon Islands Dollar",
  },
  {
    "currencyCode": "SOS",
    "currencyName": "Somali Shilling",
  },
  {
    "currencyCode": "ZAR",
    "currencyName": "South African Rand",
  },
  {
    "currencyCode": "KRW",
    "currencyName": "South Korean Won",
  },
  {
    "currencyCode": "SSP",
    "currencyName": "South Sudanese Pound",
  },
  {
    "currencyCode": "LKR",
    "currencyName": "Sri Lanka Rupee",
  },
  {
    "currencyCode": "SDG",
    "currencyName": "Sudanese Pound",
  },
  {
    "currencyCode": "SRD",
    "currencyName": "Surinamese Dollar",
  },
  {
    "currencyCode": "SEK",
    "currencyName": "Swedish Krona",
  },
  {
    "currencyCode": "CHF",
    "currencyName": "Swiss Franc",
  },
  {
    "currencyCode": "SYP",
    "currencyName": "Syrian Pound",
  },
  {
    "currencyCode": "STN",
    "currencyName": "São Tomé and Príncipe Dobra",
  },
  {
    "currencyCode": "TWD",
    "currencyName": "New Taiwan Dollar",
  },
  {
    "currencyCode": "TJS",
    "currencyName": "Tajikistani Somoni",
  },
  {
    "currencyCode": "TZS",
    "currencyName": "Tanzanian Shilling",
  },
  {
    "currencyCode": "THB",
    "currencyName": "Thai Baht",
  },
  {
    "currencyCode": "GMD",
    "currencyName": "Gambian Dalasi",
  },
  {
    "currencyCode": "TOP",
    "currencyName": "Tongan Paʻanga",
  },
  {
    "currencyCode": "TTD",
    "currencyName": "Trinidad and Tobago Dollar",
  },
  {
    "currencyCode": "TND",
    "currencyName": "Tunisian Dinar",
  },
  {
    "currencyCode": "TRY",
    "currencyName": "Turkish Lira",
  },
  {
    "currencyCode": "TMT",
    "currencyName": "Turkmenistan Manat",
  },
  {
    "currencyCode": "TVD",
    "currencyName": "Tuvaluan Dollar",
  },
  {
    "currencyCode": "UGX",
    "currencyName": "Ugandan Shilling",
  },
  {
    "currencyCode": "UAH",
    "currencyName": "Ukrainian Hryvnia",
  },
  {
    "currencyCode": "GBP",
    "currencyName": "Pound Sterling",
  },
  {
    "currencyCode": "USD",
    "currencyName": "United States Dollar",
  },
  {
    "currencyCode": "UYU",
    "currencyName": "Uruguayan Peso",
  },
  {
    "currencyCode": "UZS",
    "currencyName": "Uzbekistani So'm",
  },
  {
    "currencyCode": "VUV",
    "currencyName": "Vanuatu Vatu",
  },
  {
    "currencyCode": "VES",
    "currencyName": "Venezuelan Bolívar Soberano",
  },
  {
    "currencyCode": "VND",
    "currencyName": "Vietnamese Đồng",
  },
  {
    "currencyCode": "YER",
    "currencyName": "Yemeni Rial",
  },
  {
    "currencyCode": "ZMW",
    "currencyName": "Zambian Kwacha",
  },
  {
    "currencyCode": "ZWL",
    "currencyName": "Zimbabwean Dollar",
  },
];
